import pick from 'lodash/pick';

import { PERMISSIONS } from '~/mst/models/permissions/types';
import I18n from '~/utils/i18n';
import { IOrganizationModel } from '../model';
import { OrganizationAddressTypes } from '../types';

export default (self: IOrganizationModel) => {
  function getAddress(type: OrganizationAddressTypes) {
    return self.addresses?.find((address) => address.type === type);
  }
  return {
    get searchString() {
      const searchFields = ['name', 'shippingLocation', 'external_id'];
      return Object.values(pick(self, searchFields)).join(' ').toLowerCase();
    },
    get shippingLocation() {
      const address = getAddress(OrganizationAddressTypes.shipping);
      return address?.location;
    },
    get contactFullName() {
      return [self.contact_first_name, self.contact_last_name].filter(Boolean).join(' ') || null;
    },
    get isBillingSameAsShipping() {
      const shipping = getAddress(OrganizationAddressTypes.shipping);
      const billing = getAddress(OrganizationAddressTypes.billing);
      if (!billing) return true;
      const keys = ['street', 'city', 'state', 'zip_code', 'country'] as const;
      return keys.every((k) => (shipping?.[k] || '') === (billing[k] || ''));
    },
    get permissionValueLabelPairs() {
      return (self.permissions || []).map((item) => ({
        value: item,
        label: I18n.t(`permissions.${item}`)
      }));
    },
    get hasManagerAccess() {
      return self.permissions.includes(PERMISSIONS.ManageUsers);
    },
    get canManageReports() {
      return self.permissions.includes(PERMISSIONS.ManageReports);
    },
    get canReadReports() {
      return self.permissions.includes(PERMISSIONS.ReadReports);
    },
    get canManageDashboards() {
      return self.permissions.includes(PERMISSIONS.ManageDashboards);
    },
    get canManageSharedDashboards() {
      return self.permissions.includes(PERMISSIONS.ManageSharedDashboards);
    },
    get hasOwnerAccess() {
      return self.permissions.includes(PERMISSIONS.ManageOrganizations);
    },
    get hasAdminAccess() {
      return self.permissions.includes(PERMISSIONS.AdminDevices);
    },
    get isAethair() {
      return self.name?.toLowerCase().includes('aethair');
    }
  };
};
